import { useTranslations } from "next-intl";
import Link from "next/link";

interface ProductTagsProps {
  tags: { id: number, name: string }[]
}

const ProductTags: React.FC<ProductTagsProps> = ({ tags }) => {
  const t = useTranslations()
  return (tags.length ? (<div className="flex flex-wrap items-center text-[#999999] font-normal text-xs ">
    <span className="">{`${t("client_productdetails_alltags")}:`}</span>
    {tags.map((tag, idx) => (
      <div className="flex" key={`tag-${tag.id}`}>
        <span className={`mx-2`}>
          <Link
            href={`/product?tags_id=${tag.id}`}
            passHref
            prefetch={false}
            className=" text-brandBlue hover:text-brandBlue"
            legacyBehavior>

            {tag.name}

          </Link>
        </span>
        {idx + 1 >= tags.length ? null : <span>|</span>}
      </div>
    ))}
  </div>) : null);
}

export default ProductTags;